import React from 'react';
import _ from 'lodash';
import StyledPopper from 'components/StyledPopper';
import CycleTimeTrendWidget, {
  resolveTickConfig
} from './CycleTimeTrendWidget';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';

const CycleTimeTrendPopper = ({ anchorEl, data = {}, onClose }) => {
  const hasXData = Object.keys(_.get(data, 'x', {})).length > 0;
  const hasYData = Object.keys(_.get(data, 'y', {})).length > 0;

  if (!hasXData || !hasYData) {
    return null;
  }

  const tickConfig = resolveTickConfig(data.y);
  if (!tickConfig) {
    return null;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const metricsCalculationConfig = useMetricsCalculationConfig();

  return (
    <StyledPopper
      id={'transitions-popper'}
      anchorEl={anchorEl}
      onClose={onClose}
      transition
      placement='bottom'
      style={{ zIndex: 1000 }}
      title='CYCLE TIME ITERATION TREND'
    >
      <CycleTimeTrendWidget
        data={data}
        metricsCalculationConfig={metricsCalculationConfig}
      />
    </StyledPopper>
  );
};

export default CycleTimeTrendPopper;
